import { CellProps } from '@/components/bulkQueue/types';
import { VisitPriorityIcon } from '@/components/icons/PriorityIcon';
import { renderVisitPriority } from '@/types/visit';
import { Tooltip } from '@mui/material';
import { FC } from 'react';

export const PriorityRenderCell: FC<CellProps> = (props) => {
    const { priority } = props.entity;

    if (!priority) {
        return null;
    }

    return (
        <Tooltip title={`${renderVisitPriority(priority)} Priority`}>
            <div>
                <VisitPriorityIcon priority={priority} />
            </div>
        </Tooltip>
    );
};
